import * as React from 'react'

import { Site } from '@envato/foundation-types'

import { config } from '../../../../common/config'
import NextGenImageWrapper from '../../nextGenImageWrapper'
import SeoHeadings from '../../seoHeadings/seoHeadings'

import * as styles from './searchHeaderBlock.module.css'
import * as seoHeadingsSmallStyles from '../../../components/seoHeadings/themes/homepage.newdesign.small.module.css'
import * as classnames from 'classnames'

interface IProps {
  header?: string
  subheading?: string
  currentSite: Site
}

const getDesktopImageUrl = (currentSite: string) => {
  return `${config.assets.PUBLIC_PATH}/images/home-page/new-design/${currentSite}/search-header-1600749088571.webp`
}

const SearchHeaderBlock: React.SFC<IProps> = ({
  children,
  currentSite,
  header,
  subheading
}) => {
  const imageStyle =
    currentSite === Site.audiojungle
      ? styles.imageWrapperAudio
      : styles.imageWrapper

  const headerStyle = seoHeadingsSmallStyles
  const seoHeaderClass = styles.seoHeader

  return (
    <section className={styles.root}>
      <div className={classnames(styles.wrapper)}>
        <div className={styles.autosuggestWrapper}>
          <div className={seoHeaderClass}>
            <SeoHeadings
              TagName="h1"
              heading={
                header || 'Discover thousands of web themes and templates'
              }
              subHeading={subheading || ''}
              styles={headerStyle}
            />
          </div>
          <div className={styles.childrenContainer}>{children}</div>
        </div>

        <div className={imageStyle}>
          <NextGenImageWrapper>
            <img
              src={getDesktopImageUrl(currentSite)}
              alt={`${currentSite} hero image`}
              className={styles.image}
            />
          </NextGenImageWrapper>
        </div>
      </div>
    </section>
  )
}

export default SearchHeaderBlock
